import { FunctionComponent, useEffect } from 'react';

import { IDonutWithText } from 'PDF/components/Charts/types';
import { useGenerateImageFromCharts } from 'PDF/hooks/useGenerateImageFromCharts';

import { DonutWithText } from './DonutWithText';

interface IDonutWithTextWrapper {
  info: IDonutWithText;
  aspectRatio?: number;
  labelTextWidthDivider?: number;
  updateState: (title: string, src: string) => void;
}

export const DonutWithTextWrapper = ({
  aspectRatio,
  info,
  updateState,
  labelTextWidthDivider,
}: IDonutWithTextWrapper) => {
  const [chartPortal, chartImgSrc] = useGenerateImageFromCharts(DonutWithText as FunctionComponent, {
    aspectRatio,
    info,
    labelTextWidthDivider,
  });

  useEffect(() => {
    if (chartImgSrc) {
      updateState(info.title, chartImgSrc as string);
    }
  }, [chartImgSrc]);

  return <>{chartPortal}</>;
};
